export default "/_next/static/images/service-sitting-desktop-3x-14d92cb01e239e7dba58cff15453b667.jpg";